import React from 'react';
import styles from './style.module.scss';
import { Grid } from '@material-ui/core';

const CatalogueStats = (props) => {
    return <React.Fragment>
        <div className="container-fluid p-0">
            <Grid container alignItems="center" spacing={3} className={`${styles.statContainer}`}>
                <Grid item auto="true" onClick={() => props.handleTab('all')}>
                    <div className={styles.ordersDiv} >
                        <span className="d-flex align-items-center">
                            <strong className={styles.count}>{props.stats.total}</strong> <span className=""> Total Inventory</span>
                        </span>
                    </div>
                </Grid>
                <Grid item auto="true" onClick={() => props.handleTab('active')}>
                    <div className={styles.ordersDiv}>
                        <span className="d-flex align-items-center">
                            <strong className={styles.count}>{props.stats.active}</strong> <span className=""> Active Inventory</span>
                        </span>
                    </div>
                </Grid>
                <Grid item auto="true" onClick={() => props.handleTab('inactive')}>
                    <div className={styles.ordersDiv}>
                        <span className="d-flex align-items-center">
                            <strong className={styles.count}>{props.stats.inactive}</strong> <span className=""> Inactive Inventory</span>
                        </span>
                    </div>
                </Grid>
                <Grid item auto="true" onClick={() => props.handleTab('pending')}>
                    <div className={styles.ordersDiv}>
                        <span className="d-flex align-items-center">
                            <strong className={styles.count}>{props.stats.pending}</strong> <span className=""> Pending Approval</span>
                        </span>
                    </div>
                </Grid>
            </Grid>
        </div>
    </React.Fragment>
}

export default CatalogueStats;